import {useCallback, useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {STORAGE_KEY} from "utils";
import {SEARCH_PARAMS} from "components/Layout/constants";

function useRecentSearchKeywords(onChangeInput) {
  const recentSearchKeywords = JSON.parse(localStorage.getItem(STORAGE_KEY.recentSearchKeyword)) || [];
  const [searchParams] = useSearchParams();
  const searchKeyword = searchParams.get(SEARCH_PARAMS.SEARCH);
  const [, setRecentKeywords] = useState(recentSearchKeywords);

  const saveRecentSearchKeyword = keyword => {
    if (!keyword?.trim()?.length) return;

    if (recentSearchKeywords?.length >= 10) {
      recentSearchKeywords.shift();
    }

    let updatedKeywords = [];
    if (recentSearchKeywords.includes(keyword)) {
      updatedKeywords = recentSearchKeywords.filter(recentKeyword => {
        return recentKeyword !== keyword;
      });
    } else {
      updatedKeywords = [...recentSearchKeywords];
    }

    updatedKeywords.push(keyword);

    localStorage.setItem(STORAGE_KEY.recentSearchKeyword, JSON.stringify(updatedKeywords));
  };

  const deleteRecentSearchKeyword = () => {
    localStorage.removeItem(STORAGE_KEY.recentSearchKeyword);
    setRecentKeywords(recentSearchKeywords);
  };

  const syncValueOnClickRecentKeyword = useCallback(() => {
    if (searchKeyword) {
      onChangeInput?.(searchKeyword);
    }
  }, [onChangeInput, searchKeyword]);

  useEffect(() => {
    syncValueOnClickRecentKeyword();
  }, [searchKeyword, syncValueOnClickRecentKeyword]);

  return {saveRecentSearchKeyword, syncValueOnClickRecentKeyword, deleteRecentSearchKeyword, recentSearchKeywords};
}

export default useRecentSearchKeywords;
